import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tipoAtraso'
})
export class TipoAtrasoPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if(value >= 0 && value <= 3){
      return '1';
    }else if(value > 3 && value <= 6){
      return '2';
    }else if(value >= 7){
      return '3';
    }else{
      return value;
    }
  }

}
